import { GlobalState } from '../../actions';
import { ServerType } from '../../System/systemConfig';

export const webUsageSelector = (state: GlobalState) => state.webUsage;

export const webUsageSummarySelector = (server: ServerType) => (state: GlobalState) =>
    webUsageSelector(state)[server] ? webUsageSelector(state)[server].summary : undefined;
export const webUsageDetailSelector = (server: ServerType) => (state: GlobalState) =>
    webUsageSelector(state)[server] ? webUsageSelector(state)[server].details : undefined;
